import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'boxicons/css/boxicons.min.css'
import 'material-icons/iconfont/material-icons.css'
import 'typeface-inter'
import { getAuth, onAuthStateChanged } from "firebase/auth"
import { firebaseApp } from "@/firebaseConfig"

Vue.use(Vuesax)
Vue.config.productionTip = false

const auth = getAuth(firebaseApp)

let app
onAuthStateChanged(auth, () => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})